import {charcoal} from '../sass/base/_exports.sass';

export const RevealIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 24;
  const height = 24;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M11.6101 3.22266C11.6629 7.55179 8.44677 12.5558 5.38867 12.5558"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M3.05566 11.7793L5.38894 12.5571"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M5.38867 12.5547C6.76737 14.3776 7.4037 15.5929 7.72195 20.3323"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M6.94405 7.89062C6.38848 10.4238 5.27736 12.2906 3.83301 12.5572"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M4.59338 8.66797C4.73313 9.91238 4.03415 11.2606 3.05566 11.779"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M3.05566 3.22266V20.3334"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M11.612 3.22266C11.5527 7.55179 15.1708 12.5558 18.6112 12.5558"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M20.9436 11.7793L18.6104 12.5571"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M18.6106 12.5547C17.2319 14.3776 16.5956 15.5929 16.2773 20.3323"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M17.0547 7.89062C17.6102 10.4238 18.7214 12.2906 20.1657 12.5572"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M19.4065 8.66797C19.2667 9.91238 19.9657 11.2606 20.9442 11.779"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M20.9434 3.22266V20.3334"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M22.4995 1.66797H1.5V3.22349H22.4995V1.66797Z"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={color}
        d="M1.5 20.334H22.4995"
        stroke="#101B21"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
